import {memo, useRef, useState} from 'react'
import {css} from '@emotion/react'
import {publish} from '@/script/event.mjs'
import {useTreeDocContext} from '@/components/TreeDoc/index.mjs'
import usePointer from '@/hooks/usePointer.mjs'

const COLOR_SELECTED = 'rgba(233, 84, 32, 1)'
const COLOR_HOVERED = 'rgba(233, 84, 32, .3)'

const cssNodeOuterBox = css({
    position: 'relative',
    backgroundRepeat: 'no-repeat',
    outline: '2px solid transparent',
    outlineOffset: 2,
    pointerEvents: 'auto',

    '&:hover': {
        outlineColor: COLOR_HOVERED,
    },
})

const cssNodeOuterBoxSelected = css({
    outlineColor: COLOR_SELECTED,

    '&:hover': {
        outlineColor: COLOR_SELECTED,
    },
})

const useStyle = (map, node) => {
    const [rect, setRect] = useState({width: 0, height: 0})
    const [shape, paddings] = map.useNodeShape(node, rect)

    const style = {
        backgroundImage: `url('${shape}')`,
        padding: paddings.map((n) => `${n}px`).join(' '),
    }

    return [style, setRect]
}

const NodeOuterBox = ({node, ...props}) => {
    const map = useTreeDocContext()
    const refEl = useRef()
    map.useRegisterDom('nodes', node, refEl)
    map.useNodeChange(node, ['data'])
    const isEditingText = map.useIsEditingText(node)
    const isSelected = map.useIsNodeSelected(node)
    const title = map.getNodeTitle(node)

    const eventHandlers = {
        ...usePointer({
            onClick: event => publish(map, 'node_click', {event, node}),

            onDoubleClick: event => publish(
                map, 'node_double_click', {event, node}
            ),

            onPointerDown: e => {
                e.stopPropagation()

                // 阻止输入框失焦
                if (isEditingText) {
                    e.preventDefault()
                }
            },
        }),

        onContextMenu: event => {
            event.preventDefault()
            publish(map, 'node_click', {event, node})
            publish(map, 'node_context_menu', {event, node})
        },
    }

    const csss = [cssNodeOuterBox]

    if (isSelected) {
        csss.push(cssNodeOuterBoxSelected)
    }

    const [style, onInnerBoxResize] = useStyle(map, node)

    return (
        <div
            ref={refEl}
            css={csss}
            style={style}
            title={title}
            {...eventHandlers}
            {...props}
        >
            <map.components.TreeJoint node={node} />

            <map.components.NodeInnerBox
                node={node}
                onResize={onInnerBoxResize}
            />
        </div>
    )
}

const MemorizedNodeOuterBox = memo(NodeOuterBox, () => true)
MemorizedNodeOuterBox.displayName = 'NodeOuterBox'

export default MemorizedNodeOuterBox
